import { IconFont } from '@byecode/ui'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type { FilterFormType } from '@lighthouse/core'
import { FilterMode } from '@lighthouse/core'
import type { FlowNode } from '@lighthouse/shared'
import { TagIcon } from '@lighthouse/shared'
import { Collapse } from '@mantine/core'
import React, { useMemo } from 'react'

import { TriggerFilter } from '../../TriggerFilter'
import * as SC from './BranchItemStyles'

interface VariableItemProps {
    id: string
    opened: boolean
    prefixName?: string
    index: number
    len: number
    allSingleParentNodes: FlowNode[]
    onChangeOpen: (opened: boolean) => void
    onDelete: (id: string) => void
    onChange: (val: FilterFormType | undefined) => void
    value: FilterFormType
}

const BranchItem: React.FunctionComponent<VariableItemProps> = ({
    value,
    id,
    opened,
    prefixName,
    onChangeOpen,
    onDelete,
    allSingleParentNodes,
    index,
    len,
    onChange
}) => {
    const { attributes, listeners, setNodeRef, transform, transition, active } = useSortable({
        id
    })

    const style: React.CSSProperties = useMemo(
        () => ({
            transform: CSS.Transform.toString(transform && { ...transform, scaleY: 1 }),
            transition,
            zIndex: active?.id === id ? 1 : 0
        }),
        [active?.id, transform, transition, id]
    )

    const name = prefixName || '情况'

    const conditionName = useMemo(() => {
        if (index === 0) {
            return '如果'
        }
        return '否则如果'
    }, [index])

    return (
        <SC.Container {...attributes} style={style} ref={setNodeRef}>
            <SC.Header>
                <SC.HeaderLeft>
                    <SC.Handle {...listeners} style={{ cursor: 'grab' }}>
                        <IconFont size={16} type="DotsSix" color="var(--color-gray-500)" />
                    </SC.Handle>
                    <SC.Title>
                        {name}
                        {index + 1}
                    </SC.Title>
                    <SC.Condition>{conditionName}</SC.Condition>
                </SC.HeaderLeft>
                <SC.RightFill style={{ width: 'auto' }}>
                    {len !== 1 && <TagIcon icon="Trash" iconColor="var(--color-gray-500)" onClick={() => onDelete?.(id)} />}
                    <IconFont
                        size={16}
                        color="var(--color-gray-500)"
                        type={opened ? 'ArrowUpSmall' : 'ArrowDownSmall'}
                        onClick={() => onChangeOpen(!opened)}
                    />
                </SC.RightFill>
            </SC.Header>
            <Collapse in={opened}>
                <SC.Content>
                    <TriggerFilter
                        value={value}
                        onChange={onChange}
                        sourceFieldFlowNode={allSingleParentNodes}
                        prefix="config"
                        paramsMode={FilterMode.CUSTOM}
                        fieldMode={FilterMode.CUSTOM}
                    />
                </SC.Content>
            </Collapse>
        </SC.Container>
    )
}

export default BranchItem
